<template>
    <div class="m-cart__invoice">
        <template v-for="(value, key) in invoiceModel">
            <div
                v-if="key !== 'payable_price'"
                :key="key"
                class="m-cart__invoice__content"
            >
                <span class="m-cart__invoice__content-title">
                    {{ $t(`cart.invoice.${key}`) }}
                </span>
                <span class="m-cart__invoice__content-value">
                    {{ valueReviewer(key, value) }}
                </span>
            </div>
            <div
                v-else-if="key === 'payable_price'"
                :key="`${key}`"
                class="m-cart__invoice__content payable-price"
            >
                <span class="m-cart__invoice__content-title">
                    {{ $t(`cart.invoice.${key}`) }}
                </span>
                <span class="m-cart__invoice__content-value">
                    {{ valueReviewer(key, value) }}
                </span>
            </div>
        </template>

        <y-button
            :content="buttonContent || $t('cart.invoice.next_step')"
            :disabled="disableNext"
            loading-on="loading-payment-button"
            color="primary"
            class="m-cart__invoice__next-button mt-4"
            flat
            @click.prevent="nextAction"
        />

        <p
            v-if="disableNext && nextHint && nextHint.length"
            class="m-cart__invoice__next-hint"
        >
            {{ nextHint }}
        </p>

        <div class="m-cart__invoice__mobile-action">
            <div
                v-if="get(invoiceModel, 'payable_price')"
                class="m-cart__invoice__content payable-price"
            >
                <span class="m-cart__invoice__content-title">
                    {{ $t('cart.invoice.payable_price') }}
                </span>
                <span class="m-cart__invoice__content-value">
                    {{ valueReviewer('payable_price', get(invoiceModel, 'payable_price')) }}
                </span>
            </div>
        </div>
    </div>
</template>

<script>
    import { separated } from '@nodes/helpers/number';

    export default {
        name: 'Invoice',

        props: {
            /**
             * Invoice Model
             */
            invoiceModel: {
                type: Object,
            },

            /**
             * Disable to go next step
             */
            disableNext: {
                type: Boolean,
            },

            /**
             * Next Button Content
             */
            buttonContent: {
                type: String,
            },

            /**
             * A hint for enable next button
             */
            nextHint: {
                type: String,
            },
        },

        methods: {
            separated,

            /**
             * Next action
             */
            nextAction() {
                this.$emit('next');
                window.scrollTo(0, 0);
            },

            /**
             * Return acceptable value for invoice
             *
             * @param {string} key - key of invoice model
             * @param {number|undefined} value - value of invoice item
             * @returns {string | number}
             */
            valueReviewer(key, value) {
                if (key === 'cost_shipping') {
                    return this.costShipping(value);
                }
                if (value === 0) {
                    return '-';
                }
                if (key === 'wares_count') {
                    return this.$t('cart.invoice.count', [this.separated(value, this.$i18n.locale)]);
                }
                return this.$t('cart.invoice.price_unit', [this.separated(value, this.$i18n.locale)]);
            },

            /**
             * Return Cost shipping value
             *
             * @param {number|undefined} value
             * @returns {number | string}
             */
            costShipping(value) {
                if (value === undefined) {
                    return this.$t('cart.shipping_list.undefined');
                }
                if (value === 0) {
                    return this.$t('cart.shipping_list.free');
                }
                return this.$t('cart.invoice.price_unit', [this.separated(value, this.$i18n.locale)]);
            },
        },
    };
</script>
